"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Dictionary = /*#__PURE__*/function () {
  function Dictionary(translations) {
    var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
    (0, _classCallCheck2.default)(this, Dictionary);
    (0, _defineProperty2.default)(this, "translations", void 0);
    (0, _defineProperty2.default)(this, "language", void 0);
    this.translations = translations;
    this.language = language;
  }

  (0, _createClass2.default)(Dictionary, [{
    key: "setLanguage",
    value: function setLanguage() {
      var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
      this.language = language;
    }
  }, {
    key: "t",
    value: function t(key) {
      var translation = this.translations[key]; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore

      return translation[this.language] || translation.en || translation.ru;
    }
  }]);
  return Dictionary;
}();

var _default = Dictionary;
exports.default = _default;